import {defaultRoute} from "@/components/forSale/routes";

const namespaced = true;

const defaultState = () => {
  return {
    route: defaultRoute,
    selectionListColumns: [
      {
        name: 'Delete',
        val: 'delete',
        visible: true,
      },
      {
        name: 'Unit',
        val: 'unit',
        visible: true,
      },
      {
        name: 'VIN',
        val: 'vin',
        visible: true,
      },
      {
        name: 'Company',
        val: 'company',
        visible: true,
      },
      {
        name: 'Location',
        val: 'location',
        visible: true,
      },
      {
        name: 'Group',
        val: 'group',
        visible: true,
      },
      {
        name: 'Class',
        val: 'class',
        visible: true,
      },
      {
        name: 'Model Year',
        val: 'model_year',
        visible: true,
      },
      {
        name: 'Make',
        val: 'make',
        visible: true,
      },
      {
        name: 'Model',
        val: 'model',
        visible: true,
      },
      {
        name: 'Model Detail',
        val: 'model_detail',
        visible: true,
      },
      {
        name: 'Color',
        val: 'color',
        visible: true,
      },
      {
        name: 'Condition',
        val: 'condition',
        visible: true,
      },
      {
        name: 'Mileage',
        val: 'mileage',
        visible: true,
      },
      {
        name: 'Grade',
        val: 'grade',
        visible: true,
      },
      {
        name: 'State',
        val: 'state',
        visible: true,
      },
    ],
    historyListColumns: [
      {
        name: 'Vehicles',
        val: 'vehicles',
        visible: true,
      },
      {
        name: 'Amount',
        val: 'amount',
        visible: true,
      },
      {
        name: 'Result',
        val: 'result',
        visible: true,
      },
      {
        name: 'Paid',
        val: 'paid_at',
        visible: true,
      },
      {
        name: 'Completed at',
        val: 'completed_at',
        visible: true,
      },
      {
        name: 'Created at',
        val: 'created_at',
        visible: true,
      },
      {
        name: 'Actions',
        val: 'actions',
        visible: true,
      },
    ],
    selectedItems: [],
    isImportModalOpen: false,
    isSaveVehicles: false,
    historyFilter: {
      changed: false,
      result: null,
      is_paid: null,
      is_completed: null,
    },
    selectedHistoryItems: [],
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_ROUTE(state, route) {
    state.route = route;
  },
  SET_SELECTION_LIST_COLUMNS(state, columns) {
    state.selectionListColumns = columns;
  },
  SET_HISTORY_LIST_COLUMNS(state, columns) {
    state.historyListColumns = columns;
  },
  SET_SELECTED_ITEMS(state, items) {
    state.selectedItems = items;
  },
  SET_IS_IMPORT_MODAL(state, isImportModalOpen) {
    state.isImportModalOpen = isImportModalOpen;
  },
  SET_IS_SAVE_VEHICLES(state, isSaveVehicles) {
    state.isSaveVehicles = isSaveVehicles;
  },
  SET_HISTORY_FILTER(state, historyFilter) {
    state.historyFilter = historyFilter;
  },
  SET_SELECTED_HISTORY_ITEMS(state, items) {
    state.selectedHistoryItems = items;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
